import { render, staticRenderFns } from "./PageBlock.vue?vue&type=template&id=977f595e&scoped=true"
import script from "./PageBlock.vue?vue&type=script&lang=js"
export * from "./PageBlock.vue?vue&type=script&lang=js"
import style0 from "./PageBlock.vue?vue&type=style&index=0&id=977f595e&prod&lang=scss&scoped=true"
import style1 from "./PageBlock.vue?vue&type=style&index=1&id=977f595e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977f595e",
  null
  
)

export default component.exports